export default __webpack_public_path__ + "static/media/recruit_bg.05e3ee4d.png";